import styled, { css } from 'styled-components';

import { Font, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type HtmlContentProps = {
  html: string;
  font?: Font;
};

export const htmlContentStyles = css`
  color: ${theme.color.textPrimary};
  overflow-wrap: break-word;

  p {
    margin: 0;
    padding: 0;

    &:empty {
      padding: ${pxToRem(12)} 0;
    }
  }

  ol,
  ul {
    margin: ${pxToRem(4)};
    list-style-position: inside;
  }

  li > p {
    display: inline;
  }

  a {
    color: ${theme.color.elementBlue100};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const HtmlContent = ({ html, font = 'regular16' }: HtmlContentProps) => {
  return <Content $font={font} dangerouslySetInnerHTML={{ __html: html }} />;
};

const Content = styled.div<{ $font: Font }>`
  font: ${({ $font }) => theme.font[$font]};
  ${htmlContentStyles}
`;
